import { api } from '../middleware/api';

export interface AmSeedGroup {
  key: string;
  label: string;
  suggested: boolean;
  categoryCount: number;
  productCount: number;
  newCategories: number;
  newProducts: number;
}

export const amseedApi = api
  .enhanceEndpoints({ addTagTypes: ['AmCategory', 'AmProduct'] })
  .injectEndpoints({
    endpoints: builder => ({
      getAmSeedPreview: builder.query<AmSeedGroup[], void>({
        query: () => 'amseed',
        keepUnusedDataFor: 0
      }),
      seedAmCatalogue: builder.mutation<{ addedCategories: number; addedProducts: number }, string[]>({
        query: groups => ({ url: 'amseed', method: 'POST', body: { groups } }),
        invalidatesTags: ['AmCategory', 'AmProduct']
      })
    }),
    overrideExisting: false
  });

export const { useGetAmSeedPreviewQuery, useSeedAmCatalogueMutation } = amseedApi;
